module.exports = __webpack_public_path__ + "static/img/hmo1.f9bfce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hmo/hmo1.png
// module id = PI25
// module chunks = 11